import { render, staticRenderFns } from "./ProductListModal.vue?vue&type=template&id=e643b80e"
import script from "./ProductListModal.vue?vue&type=script&lang=js"
export * from "./ProductListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports